import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { RoleUserTiamDto } from '../domain/models/roleTiam';
import IDisplayTiam from '../domain/ports/display/i-display-tiam';
import { ApiResponse, ApiResponseList, PaginatedData } from '../domain/models/apiResponse';

@Injectable({ providedIn: 'root' })
export class TiamAdapterService implements IDisplayTiam {
  private baseUrl = environment.urlApi;

  constructor(private http: HttpClient) {}

  GetStatusRole(role: string): Observable<ApiResponse<string>> {
    return this.http.get<ApiResponse<string>>(`${this.baseUrl}api/v1/Auth/statusRole`, { params: { role } }).pipe(
            catchError(err => {
              console.error("Error in get status roles tiam", err);
              throw err;
            })
          );
  }

  RequestNewRole(role: string): Observable<ApiResponse<boolean>> {
      return this.http.post<ApiResponse<boolean>>(`${this.baseUrl}api/v1/Auth`, 
      JSON.stringify(role), 
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      }).pipe(
            catchError(err => {
              console.error("Error in RequestNewRole", err);
              throw err;
            })
          );
  }

  GetRolesUserTiam(): Observable<ApiResponseList<RoleUserTiamDto>> {
      return this.http.get<ApiResponseList<RoleUserTiamDto>>(`${this.baseUrl}api/v1/Auth`, {}).pipe(
            catchError(err => {
              console.error("Error in get roles tiam", err);
              throw err;
            })
          );
  }  
}
